module.exports = __webpack_public_path__ + "img/shart-4.432b2a7d.png";